import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceHide16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_255)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.53039 0.469666L4.76823 3.7075C8.84313 1.4157 12.7304 4.10049 15.4188 7.3265C15.8141 7.80087 15.8141 8.19913 15.4188 8.6735C14.5608 9.70306 13.5863 10.6488 12.5126 11.4518L15.5304 14.4697L14.4697 15.5303L11.2317 12.2923C7.15675 14.5844 3.26933 11.8997 0.580877 8.6735C0.208401 8.22652 0.185764 7.80064 0.580877 7.3265C1.43891 6.29685 2.41347 5.351 3.48735 4.54795L0.469732 1.53033L1.53039 0.469666ZM5.87771 4.81699L6.45003 5.3893C8.98222 3.88263 12.1952 6.88721 10.6108 9.55005L11.4394 10.3787C12.39 9.69424 13.2484 8.87877 14.0207 8C11.9644 5.66012 9.05369 3.24468 5.87771 4.81699ZM9.55012 10.6107L10.1223 11.1828C6.94616 12.7554 4.03536 10.34 1.97894 8C2.75128 7.12114 3.60979 6.30559 4.56054 5.62114L5.38937 6.44996C3.83795 9.05736 6.94272 12.1621 9.55012 10.6107ZM6.52182 7.58241C6.20326 8.71235 7.31179 9.79004 8.41767 9.47826L6.52182 7.58241ZM9.47833 8.4176L7.58248 6.52175C8.71242 6.20319 9.79011 7.31172 9.47833 8.4176Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_255'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='matrix(-1 0 0 1 16 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

AppearanceHide16.displayName = 'AppearanceHide16';
export default AppearanceHide16;
